import {
  AutoComplete,
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Switch,
  Table,
  Tooltip,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import Column from 'antd/lib/table/Column';
import draftToHtml from 'draftjs-to-html';
import _ from 'lodash';
import React, { ReactNode, useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { useHistory } from 'react-router-dom';
import Panel from '../../../../shared/components/card/Panel';
import {
  APPLICATION_ID,
  GUTTOR_SPACE,
  HEALTHCHECK_GENERAL_INCLUSIONS,
  INVENTORY_MESSAGE_CONSTANTS,
  INVENTROY_CONSTANTS,
  TOOLTIP_TEXT,
} from '../../../../shared/constants/commonConstants';
import {
  Consultation,
  PackageDetailBase,
  Test,
} from '../../../../shared/models/healthcheck.model';
import {
  FetchInvestigationRequest,
  FetchInvestigationResponse,
} from '../../../../shared/models/investigation.model';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { array_move, base64UrlEncode, error, extractSecondLevelBaseUrl, GetFirstElement, replaceRsAndComma, success } from '../../../../utils/utility';
import {
  FETCH_INVESTIGATIONS,
  INVENTORY_SAVE_HEALTHCHECK,
  DOCTORS_DEPARTMENTS,
  DEPARTMENT_HC,
} from './../../../../shared/constants/urlEndPoints';
import '../../../../shared/components/editor/HtmlEditor.less';
import { ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import { ReactComponent as CloseIcon } from '../../../../assets/images/svg/i_close.svg';
import FormModal from '../../../../shared/components/modal/FormModal';
import MasterPackages from './MasterPackages';
import NumberFormat from 'react-number-format';

const HealthCheckPackageForm = ({ path, hcData, onFormSubmit, isSubmit, isFinalSubmit, isNewPackage,
  isMaster, onMasterSelect }: any): any => {
  const pushHistory = useHistory();
  const { Option } = Select;
  const [departments, setDepartments] = useState(null as any);
  const [departmentSelectId, setDepartmentSelectId] = useState(null as any);
  const [consultations, setConsultations] = useState(null as any);
  const [testSelected, setTestSelected] = useState(null as any);
  const [consulationSelected, setConsultationSelected] = useState(null as any);
  const [specificInstructions, setSpecificInstructions] = useState(null as any);
  const [specificInstructionText, setSpecificInstructionText] = useState(
    null as any,
  );
  const [healthCheckGeneralInstruction, setHealthCheckGeneralInstruction] = useState(null as any);
  const [editorHtmlText, setEditorHtmlText] = useState('<p></p>');
  const [contentState, setContentState] = useState(null as any);
  const [showMasterPackageModel, setShowMasterPackageModel] = useState(false);
  const [data, setData] = useState(null as any);
  const [isMasterPackage, setIsMasterPackage] = useState(null as any);

  const [
    checkBoxspecificInstructionText,
    setCheckBoxspecificInstructionText,
  ] = useState(false);
  const profileid = ApplicationDetail.instance.getProfileId();
  const [packageForm] = Form.useForm();

  useEffect((): void => {
    setData(hcData);
  }, [hcData]);

  useEffect((): void => {
    if (isSubmit || isFinalSubmit) {
      onSavePackage();
    }
  }, [isSubmit, isFinalSubmit]);

  useEffect((): void => {
    if (data) {
      loadHealthCheckInstruction();
    }
  }, [data]);

  const setInitialFields = (genericInstructionArray: any): void => {

    if (data === null || data === undefined) {
      return;
    }

    if (data.description) {
      setEditorHtmlText(data.description);
      const contentBlocks = convertFromHTML(data.description);
      // tslint:disable-next-line: no-shadowed-variable
      const contentState = ContentState.createFromBlockArray(contentBlocks?.contentBlocks);
      const raw = convertToRaw(contentState);
      setContentState(raw);
    }

    packageForm.setFieldsValue({
      packageName: data.packageName,
      gender: data.gender,
      packageAgeMax: data.maxAge,
      packageAgeMin: data.minAge,
      packageDescription: data.description,
      packagePrice: data.price,
      discountedPrice: data.discountedPrice,
    });
    if (data.investigations) {
      const history = [] as any;
      data.investigations?.filter((i: any): any => i.isActive).map((item: any): any => {
        if (!history.some((i: any): any => item.name === i.testname)) {
          history.push({
            id: item.id,
            groupid: item.groupId,
            groupname: item.groupName,
            testname: item.name,
            isActive: item.isActive,
          });
        }
      });
      setTestSelected(history);
    }
    if (data.consultations) {
      const history = [] as any;
      data.consultations?.filter((i: any): any => i.isActive).map((item: any): any => {
        if (!history.some((i: any): any => item.name === i.name)) {
          history.push({
            id: item.id,
            name: item.name,
            value: item.name,
            isActive: item.isActive,
          });
        }
      });
      setConsultationSelected(history);
    }

    if (data.specificInstructions) {
      const history = [] as any;
      data.specificInstructions.map((item: any): any => {
        if (!history.some((i: any): any => item === i.name)) {
          history.push({
            isChecked: true,
            value: item.value,
            isActive: true,
            isImportant: item.isImportant,
          });
        }
      });
      setSpecificInstructions(history);
    }

    if (data.generalInstructions && genericInstructionArray) {
      const _instruction = genericInstructionArray ? [...genericInstructionArray] : [];
      _instruction?.map((x: any): any => {
        data.generalInstructions?.map((y: any): any => {

          if (x.value === y.value) {
            x.isChecked = true;
            x.isImportant = y.isImportant;
            x.value = y.value;
          }
        });
      });
      setHealthCheckGeneralInstruction(_instruction);
    }
  };

  const onSavePackage = async (type?: string): Promise<any> => {
    const validationError = await packageForm.validateFields();
    if (validationError.errorFields && validationError.errorFields.length > 0) {
      return;
    }

    const contentBlocks = convertFromHTML(editorHtmlText);
    const contentText = ContentState.createFromBlockArray(contentBlocks?.contentBlocks);
    const raw = convertToRaw(contentText);
    if (editorHtmlText === null || editorHtmlText === '' || editorHtmlText === undefined
      || raw.blocks.length === 0 || raw.blocks[0].text.trim().length === 0) {
      error(INVENTORY_MESSAGE_CONSTANTS.enterDescription);
      return;
    }

    const packageDetailData = packageForm.getFieldsValue();
    if (type === 'investigation' || type === 'consultation') {
      if (
        packageDetailData &&
        !packageDetailData.packageName &&
        !packageDetailData.packagePrice
      ) {
        error(INVENTORY_MESSAGE_CONSTANTS.packageDetailRequired);
        return;
      }
    }

    const testArray = [] as any;
    const consultationArray = [] as any;
    if (testSelected) {
      testSelected.map((item: any): void => {
        const investigation: Test = {
          investigationId: item.id,
          departmentId: item.groupid,
          isActive: item.isActive,
        };
        testArray.push(investigation);
      });
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.packageTest);
      return;
    }

    if (consulationSelected) {
      consulationSelected.map((item: any): void => {
        const consul: Consultation = {
          consultationId: item.id,
          isActive: item.isActive,
        };
        consultationArray.push(consul);
      });
    }

    const specific_instruction = [] as any;
    const general_instruction = [] as any;
    if (specificInstructions) {
      const instructions = [...specificInstructions];
      const finalInstructions = instructions.filter((item: any): any => item.isChecked === true && item.isActive === true);
      finalInstructions?.map((item: any): any => {
        specific_instruction.push({
          isImportant: item.isImportant,
          value: item.value,
        });
      });
    }

    if (healthCheckGeneralInstruction) {
      const instructions = [...healthCheckGeneralInstruction];
      const finalInstructions = instructions.filter((item: any): any => item.isChecked === true && item.isActive === true);
      finalInstructions?.map((item: any): any => {
        general_instruction.push({
          isImportant: item.isImportant,
          value: item.value,
        });
      });
    }
    const packageDetails: PackageDetailBase = {
      id: data?.id || 0,
      isActive: true,
      ismaster: isMaster,
      masterId: data?.masterId || 0,
      profileId: profileid,
      statusName: INVENTROY_CONSTANTS.submit,
      package: {
        description: editorHtmlText, // packageDetailData.packageDescription,
        discountedPrice: parseInt(replaceRsAndComma(packageDetailData.discountedPrice), 10),
        gender: packageDetailData.gender,
        maxAge: packageDetailData.packageAgeMax,
        minAge: packageDetailData.packageAgeMin,
        name: packageDetailData.packageName,
        price: parseInt(replaceRsAndComma(packageDetailData.packagePrice), 10),
      },
      tests: testArray,
      consultations: consultationArray,
      specificInstructions: specific_instruction && specific_instruction.length > 0 ? specific_instruction : '',
      generalInstructions: general_instruction && general_instruction.length > 0 ? general_instruction : '',
    };
    const payload = {
      applicationId: APPLICATION_ID,
      packageDetails: [packageDetails],
    };
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + INVENTORY_SAVE_HEALTHCHECK;
    const response: any = await SendRequest.instance.post(url, payload);
    if (response && response.isSuccess) {
      success(`Package ${data && data.id ? 'updated ' : 'created '} successfully`);
      pushHistory.push(extractSecondLevelBaseUrl(path) +
        INVENTROY_CONSTANTS.hcPackageDetailRoute + base64UrlEncode(GetFirstElement(response?.ids)));
    } else if (response && response.errorMessage) {
      error(response.errorMessage);
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.packageSaveFail);
    }
    return;
  };

  const [testData, setTestData] = useState<{ value: string }[]>([]);
  const onTestSearch = (searchText: string): void => {
    if (departmentSelectId) {
      if (searchText && searchText.length > 2) {
        const reqpayload: FetchInvestigationRequest = {
          investigationName: searchText,
          groupIds: [departmentSelectId],
        };
        fetchTests(reqpayload);
      }
    } else if (searchText) {
      error(INVENTORY_MESSAGE_CONSTANTS.selectDepartment);
      return;
    }
  };
  const onTestSelect = (val: any, record: any): void => {
    const history = testSelected ? [...testSelected] : [];
    const presentData = history?.filter((item: any): any => record.value === item.testname);
    if (presentData && presentData.length === 1) {
      presentData[0].isActive = true;
    }
    if (!history.some((item: any): any => record.value === item.testname)) {
      history.push({
        id: record.key,
        groupid: record.groupid,
        groupname: record.groupname,
        testname: record.value,
        isActive: true,
        isNewlyAdded: true,
      });
    }
    setTestSelected(array_move(history, history.length - 1, 0));
  };

  const onConsultationSelect = (val: any, record: any): void => {
    const history = consulationSelected ? [...consulationSelected] : [];
    const presentData = history?.filter((item: any): any => record.value === item.name);
    if (presentData && presentData.length === 1) {
      presentData[0].isActive = true;
    }
    if (!history.some((item: any): any => record.value === item.name)) {
      history.push({
        id: record.id,
        name: record.value,
        value: record.name,
        isActive: true,
        isNewlyAdded: true,
      });
    }
    setConsultationSelected(array_move(history, history.length - 1, 0));
  };
  const onDepartmentSelect = (e: any): void => {
    setTestData([]);
    setDepartmentSelectId(e);
  };

  const onRemoveTestHandler = (record: any): void => {
    if (record) {
      const history = [...testSelected];
      history?.map((item: any): any => {
        if (item.id === record.id) {
          item.isActive = false;
        }
      });
      setTestSelected(history);
    }
  };

  const onRemoveConsulationHandler = (record: any): void => {
    if (record) {
      const history = [...consulationSelected];
      history?.map((item: any): any => {
        if (item.id === record.id) {
          item.isActive = false;
        }
      });
      setConsultationSelected(history);
    }
  };

  const fetchTests = async (payload: any): Promise<any> => {
    const url =
      process.env.REACT_APP_INVENTORY_API_BASE_URL + FETCH_INVESTIGATIONS;
    const result: any = await SendRequest.instance.post<
      FetchInvestigationRequest,
      FetchInvestigationResponse
    >(url, payload);
    if (result && result.isSuccess && result.packageDetails) {
      const tData = [] as any;
      result.packageDetails.map((item: any): any =>
        tData.push({
          key: item.id,
          groupid: item.groupId,
          name: item.id,
          groupname: item.groupName,
          value: item.name,
        }),
      );
      setTestData(tData);
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.invalidTest);
    }
  };

  const fetchDepartments = async (): Promise<void> => {
    const departmentResponse = await SendRequest.instance.get(
      process.env.REACT_APP_INVENTORY_API_BASE_URL + DEPARTMENT_HC,
    );
    if (
      departmentResponse &&
      departmentResponse.isSuccess &&
      departmentResponse.lookUpData
    ) {
      setDepartments(departmentResponse.lookUpData);
    } else if (departmentResponse?.errorMessage) {
      error(departmentResponse?.errorMessage);
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.departmentNotFound);
    }
  };

  const fetchConsultations = async (): Promise<void> => {
    const result = await SendRequest.instance.get(process.env.REACT_APP_INVENTORY_API_BASE_URL + DOCTORS_DEPARTMENTS);
    if (result && result.isSuccess && result.packageDetails) {
      const tData = [] as any;
      result.packageDetails.map((item: any): any =>
        tData.push({
          id: item.id,
          key: item.id,
          groupid: item.groupId,
          name: item.id,
          groupname: item.groupName,
          value: item.name,
        }),
      );
      setConsultations(tData);
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.consulationNotFound);
    }
  };

  const onSpecificInstruction = (checked: any): void => {
    if (checked) {
      let insData = {} as any;
      const presentInstruction = specificInstructions ? [...specificInstructions] : [];
      if (specificInstructionText !== null && specificInstructionText !== '' && specificInstructionText !== undefined) {
        const filterInstruction = presentInstruction?.filter((item: any): any => item.value === specificInstructionText);
        if (filterInstruction.length === 0) {
          insData = {
            isChecked: checked,
            value: specificInstructionText,
            isActive: true,
            isImportant: false,
          };
        }
        if (insData && !_.isEmpty(insData)) {
          presentInstruction.length === 0
            ? setSpecificInstructions([insData])
            : setSpecificInstructions([...specificInstructions, insData]);
          setSpecificInstructionText('');
          setCheckBoxspecificInstructionText(false);
        }
      }
    }
  };

  const onSpecificInstructionFilter = (checked: any, record: any, type?: any): any => {
    const history = specificInstructions ? [...specificInstructions] : [];
    const presentData = history?.filter((item: any): any => record.value === item.value);
    if (presentData && presentData.length === 1) {
      if (type) {
        presentData[0].isImportant = !presentData[0].isImportant;
        if (presentData[0].isImportant === true) {
          presentData[0].isChecked = true;
        } else {
          presentData[0].isChecked = record.isChecked;
        }
      } else {
        presentData[0].isChecked = checked;
        presentData[0].isImportant = checked === true ? presentData[0].isImportant : false;
      }
    }
    setSpecificInstructions(history);
  };

  const onGeneralInstructionFilter = (checked: any, record: any, type?: any): any => {
    const history = healthCheckGeneralInstruction ? [...healthCheckGeneralInstruction] : [];
    const presentData = history?.filter((item: any): any => record.value === item.value);
    if (presentData && presentData.length === 1) {
      if (type) {
        presentData[0].isImportant = !presentData[0].isImportant;
        if (presentData[0].isImportant === true) {
          presentData[0].isChecked = true;
        } else {
          presentData[0].isChecked = record.isChecked;
        }
      } else {
        presentData[0].isChecked = checked;
        presentData[0].isImportant = checked === true ? presentData[0].isImportant : false;
      }
    }
    setHealthCheckGeneralInstruction(history);
  };

  const loadHealthCheckInstruction = (): any => {
    const array = [] as any;
    HEALTHCHECK_GENERAL_INCLUSIONS?.map((item: any, index: number): any => {
      array.push({
        value: item,
        isChecked: isNewPackage ? true : false,
        isImportant: false,
        isActive: true,
      });
    });
    setHealthCheckGeneralInstruction(array);
    setInitialFields(array);
  };

  const onEditorContentChange = (editorText: any): any => {
    setEditorHtmlText(draftToHtml(editorText));
  };

  useEffect((): void => {
    loadHealthCheckInstruction();
    fetchDepartments();
    fetchConsultations();
  }, []);
  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  const onFilter = (inputValue: string, option: any): boolean => {
    return option.value.toUpperCase().includes(inputValue.toUpperCase());
  };

  const onSelection = (mstrPackage: any): void => {
    setShowMasterPackageModel(false);
    setData(mstrPackage);
    setIsMasterPackage(true);
    onMasterSelect();
  };

  return (
    <Row gutter={GUTTOR_SPACE}>
      <FormModal visible={showMasterPackageModel} width={'1000px'} onCancel={(): any => setShowMasterPackageModel(false)} title={'Master packages'} isFooter={false}>
        <MasterPackages onSelection={onSelection} />
      </FormModal>
      <Col md={16}>
        <Form
          {...layout}
          form={packageForm}
        >
          <Panel title={<div className="flx-center">
            <h3>Package Details</h3>
            {isNewPackage &&
              <Button disabled={isMaster}
                className={'mr-10 '}
                type="primary" onClick={(): any => setShowMasterPackageModel(true)}> Use Master Package
              </Button>
            }
          </div>}>
            <Row gutter={GUTTOR_SPACE}>
              <Col md={8}>
                <Form.Item
                  label="Package name"
                  name="packageName"
                  className={isMasterPackage ? 'readonly-inpt' : ''}
                  rules={[
                    {
                      required: true,
                      message: 'Please enter package name!',
                    },
                  ]}
                >
                  <Input readOnly={isMasterPackage} />
                </Form.Item>
              </Col>
              <Col md={8}>
                <Form.Item
                  name="gender"
                  className={isMasterPackage ? 'readonly-inpt' : ''}
                  label="Gender"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="Select gender">
                    <Option value="Male">Male</Option>
                    <Option value="Female">Female</Option>
                    <Option value="Both">Both</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col md={4}>
                <Form.Item
                  name="packageAgeMin"
                  className={isMasterPackage ? 'readonly-inpt w-100' : 'w-100'}
                  label="Age Range"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter Min age!',
                    },
                  ]}
                >
                  <InputNumber
                    placeholder="min"
                    min={1}
                    max={100}
                    className="w-100"
                  />
                </Form.Item>
              </Col>
              <Col md={4}>
                <Form.Item
                  name="packageAgeMax"
                  label="To"
                  className={isMasterPackage ? 'readonly-inpt w-100' : 'w-100'}
                  rules={[
                    {
                      required: true,
                      message: 'Please enter Max age!',
                    },
                  ]}
                >
                  <InputNumber
                    placeholder="max"
                    min={1}
                    max={100}
                    className="w-100"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={GUTTOR_SPACE}>
              <Col md={24}>
                <Form.Item
                  label="Package description"
                  className={isMasterPackage ? 'readonly-inpt' : ''}
                  name="packageDescription"
                  rules={[{ message: INVENTORY_MESSAGE_CONSTANTS.enterDescription }]}
                >
                  <div>
                    <Editor
                      contentState={contentState}
                      editorClassName="scroll-bar editor-style"
                      onContentStateChange={onEditorContentChange}
                      toolbar={{
                        options: ['inline', 'blockType', 'fontSize', 'fontFamily',
                          'list', 'textAlign', 'colorPicker', 'link', 'history'],
                      }}
                    />
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={GUTTOR_SPACE}>
              <Col md={12}>
                <Form.Item
                  label="Package price"
                  // Price should be editable
                  // className={isMasterPackage ? 'readonly-inpt' : ''}
                  name="packagePrice"
                  rules={[
                    {
                      required: true,
                      message: INVENTORY_MESSAGE_CONSTANTS.enterPrice,
                    },
                  ]}
                >
                  <NumberFormat
                    decimalScale={2}
                    customInput={Input}
                    thousandSeparator={true}
                    thousandsGroupStyle="lakh"
                    prefix="₹ "
                    autoComplete="off"
                    placeholder="Enter package price"
                  />
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item
                  label="Discounted price"
                  // Discounted price should be editable
                  // className={isMasterPackage ? 'readonly-inpt' : ''}
                  name="discountedPrice"
                  rules={[
                    {
                      required: true,
                      message: INVENTORY_MESSAGE_CONSTANTS.enterDiscountPrice,
                    },
                  ]}
                >
                  <NumberFormat
                    decimalScale={2}
                    customInput={Input}
                    thousandSeparator={true}
                    thousandsGroupStyle="lakh"
                    prefix="₹ "
                    autoComplete="off"
                    placeholder="Enter discounted price"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Panel>
        </Form>
        <Form
          {...layout}
        >
          <Panel title={'Tests Details'}
            extra={
              <span style={{ textAlign: 'center' }}>
                <b> {(testSelected?.filter((item: any): any => item.isActive === true)?.length) !== undefined ?
                  (testSelected?.filter((item: any): any => item.isActive === true)?.length) + ' Tests' :
                  0 + ' Tests'}
                </b>
              </span>
            }
          >
            <Row gutter={GUTTOR_SPACE}>
              <Col md={8}>
                <Row>
                  <Col md={24}>
                    <Form.Item
                      name="department"
                      className={isMasterPackage ? 'readonly-inpt' : ''}
                      label="Department"
                      rules={[{ required: testSelected ? false : true }]}
                    >
                      <Select
                        placeholder="Select department"
                        onChange={(e: any): any => onDepartmentSelect(e)}
                      >
                        {departments &&
                          departments.map(
                            (v: any, i: number): ReactNode => {
                              return (
                                <Option value={v.id} key={v.id}>
                                  {v.value}
                                </Option>
                              );
                            },
                          )}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col md={24}>
                    <Form.Item
                      name="tests"
                      className={isMasterPackage ? 'readonly-inpt' : ''}
                      label="Tests"
                      rules={[{ required: testSelected ? false : true }]}
                    >
                      <AutoComplete
                        options={testData}
                        onSelect={(val: any, option: any): any =>
                          onTestSelect(val, option)
                        }
                        onSearch={onTestSearch}
                        placeholder="Search test"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col md={16}>
                <Form.Item
                  className={isMasterPackage ? 'readonly-inpt' : ''}
                >
                  <Table
                    scroll={{ y: 300 }}
                    dataSource={testSelected?.filter((item: any): any => item.isActive === true)}
                    bordered={true}
                    size="small"
                    className="panel-table"
                    pagination={false}
                  >
                    <Column
                      width="30%"
                      title="Group name"
                      dataIndex="groupname"
                      key="groupname"
                      render={(text: any, record: any): any => {
                        return {
                          props: {
                            className: record.isNewlyAdded ? 'ant-typography-progress' : '',   // there it is!
                          },
                          children: text,
                        };
                      }}
                    />
                    <Column
                      width="60%"
                      title="Test name"
                      dataIndex="testname"
                      key="testname"
                      render={(text: any, record: any): any => {
                        return {
                          props: {
                            className: record.isNewlyAdded ? 'ant-typography-progress' : '',   // there it is!
                          },
                          children: text,
                        };
                      }}
                    />
                    <Column
                      align="center"
                      width="10%"
                      className="close-icon"
                      colSpan={3}
                      dataIndex="action"
                      key="action"
                      render={(text: any, record: any): any => (
                        <Space>
                          <Tooltip title={TOOLTIP_TEXT.remove}>
                            <CloseIcon className="fill-close"
                              onClick={(): void => onRemoveTestHandler(record)}
                            />
                          </Tooltip>
                        </Space>
                      )}
                    />
                  </Table>
                </Form.Item>
              </Col>
            </Row>
          </Panel>
        </Form>
        <Form {...layout} >
          <Row>
            <Col md={24}>
              <Panel title={'Consultation Details'}
                extra={
                  <span style={{ textAlign: 'center' }}>
                    <b>
                      {(consulationSelected?.filter((item: any): any => item.isActive === true)?.length) !== undefined ?
                        (consulationSelected?.filter((item: any): any => item.isActive === true)?.length) + ' Consultations' :
                        0 + ' Consultations'}
                    </b>
                  </span>
                }
              >
                <Row gutter={GUTTOR_SPACE}>
                  <Col md={8}>
                    <Form.Item
                      name="consultations"
                      className={isMasterPackage ? 'readonly-inpt' : ''}
                      label="Consultations"
                      rules={[{ required: consulationSelected ? false : true }]}
                    >
                      <AutoComplete
                        options={consultations}
                        onSelect={(val: any, option: any): any =>
                          onConsultationSelect(val, option)
                        }
                        filterOption={onFilter}
                        placeholder="Search consultation"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={16}>
                    <Form.Item
                      className={isMasterPackage ? 'readonly-inpt' : ''}
                    >
                      <Table
                        scroll={{ y: 300 }}
                        dataSource={consulationSelected?.filter((item: any): any => item.isActive === true)}
                        bordered={true}
                        pagination={false}
                        size="small"
                        className="panel-table"
                      >
                        <Column width="90%" title="Name" dataIndex="name" key="name"
                          render={(text: any, record: any): any => {
                            return {
                              props: {
                                className: record.isNewlyAdded ? 'ant-typography-progress' : '',   // there it is!
                              },
                              children: text,
                            };
                          }}
                        />
                        <Column
                          align="center"
                          dataIndex="action"
                          key="action"
                          className="close-icon"
                          render={(text: any, record: any): any => (
                            <Space>
                              <Tooltip title={TOOLTIP_TEXT.remove}>
                                <CloseIcon className="fill-close"
                                  onClick={(): void =>
                                    onRemoveConsulationHandler(record)
                                  }
                                />
                              </Tooltip>
                            </Space>
                          )}
                        />
                      </Table>
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
        </Form>
      </Col>
      <Col md={8}>
        <Panel title="Instructions">
          <h5 className="h5">General</h5>
          <ol className="inclusion-list is-edit">
            {healthCheckGeneralInstruction &&
              healthCheckGeneralInstruction?.filter((i: any): any => i.isActive === true)?.map(
                (item: any, index: number): any => {
                  return (
                    <li className="fsize_sm" key={index + 1}>
                      <div>
                        <Tooltip title={item.isChecked ? 'Active' : 'Inactive'}>
                          <Switch size="small"
                            checked={item.isChecked}
                            onClick={(e: any): any => onGeneralInstructionFilter(e, item)}
                          />
                        </Tooltip>
                        <a className={item.isImportant ? 'starBtn starBtnActive' : 'starBtn starBtnInActive'}
                          onClick={(e: any): any => onGeneralInstructionFilter(e, item, 'General')}>
                          <svg fill="currentColor" viewBox="0 -10 511.98685 511" xmlns="http://www.w3.org/2000/svg"><path d="m510.652344 185.902344c-3.351563-10.367188-12.546875-17.730469-23.425782-18.710938l-147.773437-13.417968-58.433594-136.769532c-4.308593-10.023437-14.121093-16.511718-25.023437-16.511718s-20.714844 6.488281-25.023438 16.535156l-58.433594 136.746094-147.796874 13.417968c-10.859376 1.003906-20.03125 8.34375-23.402344 18.710938-3.371094 10.367187-.257813 21.738281 7.957031 28.90625l111.699219 97.960937-32.9375 145.089844c-2.410156 10.667969 1.730468 21.695313 10.582031 28.09375 4.757813 3.4375 10.324219 5.1875 15.9375 5.1875 4.839844 0 9.640625-1.304687 13.949219-3.882813l127.46875-76.183593 127.421875 76.183593c9.324219 5.609376 21.078125 5.097657 29.910156-1.304687 8.855469-6.417969 12.992187-17.449219 10.582031-28.09375l-32.9375-145.089844 111.699219-97.941406c8.214844-7.1875 11.351563-18.539063 7.980469-28.925781zm0 0" fill="#ffc107" /></svg>
                        </a>
                      </div>
                      {item.value}
                    </li>
                  );
                },
              )}
          </ol>
          <Divider />
          <h5 className="h5">Specific</h5>
          <ol className="inclusion-list is-edit">
            {specificInstructions &&
              specificInstructions?.filter((i: any): any => i.isActive === true)
                ?.map((item: any, index: number): any => {
                  return (
                    <li className="fsize_sm" key={index + 1}>
                      {item.value}
                      <div>
                        <Switch size="small"
                          checked={item.isChecked}
                          onClick={(e: any): any => onSpecificInstructionFilter(e, item)}
                        />
                        <a className={item.isImportant ? 'starBtn starBtnActive' : 'starBtn starBtnInActive'}
                          onClick={(e: any): any => onSpecificInstructionFilter(e, item, 'Specific')}>
                          <svg fill="currentColor" viewBox="0 -10 511.98685 511" xmlns="http://www.w3.org/2000/svg"><path d="m510.652344 185.902344c-3.351563-10.367188-12.546875-17.730469-23.425782-18.710938l-147.773437-13.417968-58.433594-136.769532c-4.308593-10.023437-14.121093-16.511718-25.023437-16.511718s-20.714844 6.488281-25.023438 16.535156l-58.433594 136.746094-147.796874 13.417968c-10.859376 1.003906-20.03125 8.34375-23.402344 18.710938-3.371094 10.367187-.257813 21.738281 7.957031 28.90625l111.699219 97.960937-32.9375 145.089844c-2.410156 10.667969 1.730468 21.695313 10.582031 28.09375 4.757813 3.4375 10.324219 5.1875 15.9375 5.1875 4.839844 0 9.640625-1.304687 13.949219-3.882813l127.46875-76.183593 127.421875 76.183593c9.324219 5.609376 21.078125 5.097657 29.910156-1.304687 8.855469-6.417969 12.992187-17.449219 10.582031-28.09375l-32.9375-145.089844 111.699219-97.941406c8.214844-7.1875 11.351563-18.539063 7.980469-28.925781zm0 0" fill="#ffc107" /></svg>
                        </a>
                      </div>
                    </li>
                  );
                })}
          </ol>
          <Row>
            <Col md={2}>
              <Checkbox
                checked={checkBoxspecificInstructionText}
                onChange={(e: any): any =>
                  onSpecificInstruction(e?.target?.checked)
                }
              />
            </Col>
            <Col md={22}>
              <Form.Item
                className={isMasterPackage ? 'readonly-inpt' : ''}
              >
                <TextArea
                  placeholder="Value"
                  rows={2}
                  value={specificInstructionText}
                  onChange={(e: any): any =>
                    setSpecificInstructionText(e?.target?.value)
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Panel>
      </Col>
    </Row>
  );
};

export default HealthCheckPackageForm;
